<template>
  <div class="mobile message-reply">
    <div class="message_input">
      <van-field v-model="message" rows="12" class="input_field" type="textarea" maxlength="500" placeholder="请输入你的回复内容" show-word-limit />
    </div>
    <div class="message_btn" v-if="!isDesign" @click="reply">回复</div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileMessageReply",
  ctrlCaption: "消息回复",
  mixins: [$mixins.control],
  data() {
    return {
      message: ""
    }
  },
  methods: {
    reply() {
      if (!this.message) {
        dsf.layer.message('请先填写回复内容',false)
        return
      }
      let data = {
        id: this.queryString.id || '',
        detail: this.message
      }
      let that = this;
      this.$http.post('/mobile/classes/suggest/suggestReply', data).done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          this.$router.go(-1)
        } else {
          dsf.layer.message(res.message, false);
        }
      })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
    }
  }
})
</script>

<style>
</style>